/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefundPaymentRequest
 */
export interface RefundPaymentRequest {
    /**
     * Stripe PaymentIntent id (`pi_xxx`) of the original charge to refund.
     * @type {string}
     * @memberof RefundPaymentRequest
     */
    paymentIntentId: string;
    /**
     * Refund amount in minor units (cents). Must be > 0; the caller computes this from the cancellation policy and applies the zero-decimal-currency guard. Stripe rejects 0.
     * @type {number}
     * @memberof RefundPaymentRequest
     */
    amountCents: number;
    /**
     * Stripe Idempotency-Key. Reuse the same key across retries so the refund is safe to call more than once for a given booking (e.g. `refund-{booking_id}`).
     * @type {string}
     * @memberof RefundPaymentRequest
     */
    idempotencyKey: string;
    /**
     * Optional Gondola booking id — attached to Stripe metadata for traceability when reconciling.
     * @type {string}
     * @memberof RefundPaymentRequest
     */
    bookingId?: string | null;
    /**
     * Route to STRIPE_SECRET_KEY_TEST instead of the live key. Matches the charge endpoint's `test` flag.
     * @type {boolean}
     * @memberof RefundPaymentRequest
     */
    test?: boolean;
}

/**
 * Check if a given object implements the RefundPaymentRequest interface.
 */
export function instanceOfRefundPaymentRequest(value: object): value is RefundPaymentRequest {
    if (!('paymentIntentId' in value) || value['paymentIntentId'] === undefined) return false;
    if (!('amountCents' in value) || value['amountCents'] === undefined) return false;
    if (!('idempotencyKey' in value) || value['idempotencyKey'] === undefined) return false;
    return true;
}

export function RefundPaymentRequestFromJSON(json: any): RefundPaymentRequest {
    return RefundPaymentRequestFromJSONTyped(json, false);
}

export function RefundPaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefundPaymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentIntentId': json['payment_intent_id'],
        'amountCents': json['amount_cents'],
        'idempotencyKey': json['idempotency_key'],
        'bookingId': json['booking_id'] == null ? undefined : json['booking_id'],
        'test': json['test'] == null ? undefined : json['test'],
    };
}

export function RefundPaymentRequestToJSON(json: any): RefundPaymentRequest {
    return RefundPaymentRequestToJSONTyped(json, false);
}

export function RefundPaymentRequestToJSONTyped(value?: RefundPaymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_intent_id': value['paymentIntentId'],
        'amount_cents': value['amountCents'],
        'idempotency_key': value['idempotencyKey'],
        'booking_id': value['bookingId'],
        'test': value['test'],
    };
}

